/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import { useSelector } from 'react-redux';
import AuthLayout from '~/pages/_layouts/auth';
import DefaultLayout from '~/pages/_layouts/default';
import ModalComunicado from '~/components/ModalComunicado';

export default function RouteWrapper({
  component: Component,
  isPrivate,
  codigoTela,
  ...rest
}) {
  const { signed } = useSelector(state => state.auth);

  if (!signed && isPrivate) {
    return <Redirect to="/" />;
  }

  if (signed && !isPrivate) {
    return <Redirect to="/indicadores-gerais" />;
  }

  const Layout = signed ? DefaultLayout : AuthLayout;

  // remove all console.log() in any routers
  /*if (window.location.hostname !== 'localhost') {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
  }*/

  return (
    <Route
      {...rest}
      render={props => (
        <Layout>
          <>
          <ModalComunicado codigoTela={codigoTela} />
          <Component {...props} />
          </>
        </Layout>
      )}
    />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  codigoTela: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
  codigoTela: ''
};
